import SendUrls from "If_AdTool/common/sendUrl";
function coupletFloat(adData, el) {
    let event = null;
    let shichuang = 0;
	if (adData.hasOwnProperty("extCode") && adData.extCode && adData.extCode.hasOwnProperty("event")) {
		event = adData.extCode.event;
    }
    event && event.emit('playEnd');
    let {
        w,
        h,
        swfUrl,
        clickUrl,
        interac,
        delay,
        click_imp_arr,
        imp_arr,
        adText
    } = adData;
    if (typeof deconcept == "undefined") {
        var deconcept = {};
    }
    if (typeof deconcept.util == "undefined") {
        deconcept.util = {};
    }
    if (typeof deconcept.SWFObjectUtil == "undefined") {
        deconcept.SWFObjectUtil = {};
    }
    if (typeof adText == "undefined") {
        adText = "广告";
    }   
    deconcept.SWFObject = function(_1, id, w, h, _5, c, _7, _8, _9, _a, _b) {
        if (!document.getElementById) {
            return;
        }
        this.DETECT_KEY = _b ? _b: "detectflash";
        this.skipDetect = deconcept.util.getRequestParameter(this.DETECT_KEY);
        this.params = new Object();
        this.variables = new Object();
        this.attributes = new Array();
        if (_1) {
            this.setAttribute("swf", _1);
        }
        if (id) {
            this.setAttribute("id", id);
        }
        if (w) {
            this.setAttribute("width", w);
        }
        if (h) {
            this.setAttribute("height", h);
        }
        if (_5) {
            this.setAttribute("version", new deconcept.PlayerVersion(_5.toString().split(".")));
        }
        this.installedVer = deconcept.SWFObjectUtil.getPlayerVersion();
        if (c) {
            this.addParam("bgcolor", c);
        }
        var q = _8 ? _8: "high";
        this.addParam("quality", q);
        this.setAttribute("useExpressInstall", _7);
        this.setAttribute("doExpressInstall", false);
        var _d = (_9) ? _9: window.location;
        this.setAttribute("xiRedirectUrl", _d);
        this.setAttribute("redirectUrl", "");
        if (_a) {
            this.setAttribute("redirectUrl", _a);
        }
    };
    deconcept.SWFObject.prototype = {
        setAttribute: function(_e, _f) {
            this.attributes[_e] = _f;
        },
        getAttribute: function(_10) {
            return this.attributes[_10];
        },
        addParam: function(_11, _12) {
            this.params[_11] = _12;
        },
        getParams: function() {
            return this.params;
        },
        addVariable: function(_13, _14) {
            this.variables[_13] = _14;
        },
        getVariable: function(_15) {
            return this.variables[_15];
        },
        getVariables: function() {
            return this.variables;
        },
        getVariablePairs: function() {
            var _16 = new Array();
            var key;
            var _18 = this.getVariables();
            for (key in _18) {
                _16.push(key + "=" + _18[key]);
            }
            return _16;
        },
        getSWFHTML: function() {
            var _19 = "";
            if (navigator.plugins && navigator.mimeTypes && navigator.mimeTypes.length) {
                if (this.getAttribute("doExpressInstall")) {
                    this.addVariable("MMplayerType", "PlugIn");
                }
                _19 = "<embed type=\"application/x-shockwave-flash\" src=\"" + this.getAttribute("swf") + "\" width=\"" + this.getAttribute("width") + "\" height=\"" + this.getAttribute("height") + "\"";
                _19 += " id=\"" + this.getAttribute("id") + "\" name=\"" + this.getAttribute("id") + "\" ";
                var _1a = this.getParams();
                for (var key in _1a) {
                    _19 += [key] + "=\"" + _1a[key] + "\" ";
                }
                var _1c = this.getVariablePairs().join("&");
                if (_1c.length > 0) {
                    _19 += "flashvars=\"" + _1c + "\"";
                }
                _19 += "/>";
            } else {
                if (this.getAttribute("doExpressInstall")) {
                    this.addVariable("MMplayerType", "ActiveX");
                }
                _19 = "<object id=\"" + this.getAttribute("id") + "\" classid=\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\" width=\"" + this.getAttribute("width") + "\" height=\"" + this.getAttribute("height") + "\">";
                _19 += "<param name=\"movie\" value=\"" + this.getAttribute("swf") + "\" />";
                var _1d = this.getParams();
                for (var key in _1d) {
                    _19 += "<param name=\"" + key + "\" value=\"" + _1d[key] + "\" />";
                }
                var _1f = this.getVariablePairs().join("&");
                if (_1f.length > 0) {
                    _19 += "<param name=\"flashvars\" value=\"" + _1f + "\" />";
                }
                _19 += "</object>";
            }
            return _19;
        },
        write: function(_20) {
            if (this.getAttribute("useExpressInstall")) {
                var _21 = new deconcept.PlayerVersion([6, 0, 65]);
                if (this.installedVer.versionIsValid(_21) && !this.installedVer.versionIsValid(this.getAttribute("version"))) {
                    this.setAttribute("doExpressInstall", true);
                    this.addVariable("MMredirectURL", escape(this.getAttribute("xiRedirectUrl")));
                    document.title = document.title.slice(0, 47) + " - Flash Player Installation";
                    this.addVariable("MMdoctitle", document.title);
                }
            }
            if (this.skipDetect || this.getAttribute("doExpressInstall") || this.installedVer.versionIsValid(this.getAttribute("version"))) {
                var n = (typeof _20 == "string") ? document.getElementById(_20) : _20;
                n.innerHTML = this.getSWFHTML();
                return true;
            } else {
                if (this.getAttribute("redirectUrl") != "") {
                    document.location.replace(this.getAttribute("redirectUrl"));
                }
            }
            return false;
        }
    };
    deconcept.SWFObjectUtil.getPlayerVersion = function() {
        var _23 = new deconcept.PlayerVersion([0, 0, 0]);
        if (navigator.plugins && navigator.mimeTypes.length) {
            var x = navigator.plugins["Shockwave Flash"];
            if (x && x.description) {
                _23 = new deconcept.PlayerVersion(x.description.replace(/([a-zA-Z]|\s)+/, "").replace(/(\s+r|\s+b[0-9]+)/, ".").split("."));
            }
        } else {
            try {
                var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
            } catch(e) {
                try {
                    var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
                    _23 = new deconcept.PlayerVersion([6, 0, 21]);
                    axo.AllowScriptAccess = "always";
                } catch(e) {
                    if (_23.major == 6) {
                        return _23;
                    }
                }
                try {
                    axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
                } catch(e) {}
            }
            if (axo != null) {
                _23 = new deconcept.PlayerVersion(axo.GetVariable("$version").split(" ")[1].split(","));
            }
        }
        return _23;
    };
    deconcept.PlayerVersion = function(_27) {
        this.major = _27[0] != null ? parseInt(_27[0]) : 0;
        this.minor = _27[1] != null ? parseInt(_27[1]) : 0;
        this.rev = _27[2] != null ? parseInt(_27[2]) : 0;
    };
    deconcept.PlayerVersion.prototype.versionIsValid = function(fv) {
        if (this.major < fv.major) {
            return false;
        }
        if (this.major > fv.major) {
            return true;
        }
        if (this.minor < fv.minor) {
            return false;
        }
        if (this.minor > fv.minor) {
            return true;
        }
        if (this.rev < fv.rev) {
            return false;
        }
        return true;
    };
    deconcept.util = {
        getRequestParameter: function(_29) {
            var q = document.location.search || document.location.hash;
            if (q) {
                var _2b = q.substring(1).split("&");
                for (var i = 0; i < _2b.length; i++) {
                    if (_2b[i].substring(0, _2b[i].indexOf("=")) == _29) {
                        return _2b[i].substring((_2b[i].indexOf("=") + 1));
                    }
                }
            }
            return "";
        }
    };
    deconcept.SWFObjectUtil.cleanupSWFs = function() {
        if (window.opera || !document.all) {
            return;
        }
        var _2d = document.getElementsByTagName("OBJECT");
        for (var i = 0; i < _2d.length; i++) {
            _2d[i].style.display = "none";
            for (var x in _2d[i]) {
                if (typeof _2d[i][x] == "function") {
                    _2d[i][x] = function() {};
                }
            }
        }
    };
    deconcept.SWFObjectUtil.prepUnload = function() {
        if (typeof window.onunload == "function") {
            var _30 = window.onunload;
            window.onunload = function() {
                deconcept.SWFObjectUtil.cleanupSWFs();
                _30();
            };
        } else {
            window.onunload = deconcept.SWFObjectUtil.cleanupSWFs;
        }
    };
    if (typeof window.onbeforeunload == "function") {
        var oldBeforeUnload = window.onbeforeunload;
        window.onbeforeunload = function() {
            deconcept.SWFObjectUtil.prepUnload();
            oldBeforeUnload();
        };
    } else {
        window.onbeforeunload = deconcept.SWFObjectUtil.prepUnload;
    }
    if (Array.prototype.push == null) {
        Array.prototype.push = function(_31) {
            this[this.length] = _31;
            return this.length;
        };
    }
    var getQueryParamValue = deconcept.util.getRequestParameter;
    var FlashObject = deconcept.SWFObject;
    var SWFObject = deconcept.SWFObject;
    var ifengcouplet3 = {
        flagcookie: "",
        $: function(id) {
            return document.getElementById(id);
        },
        getCookie: function(N) {
            var c = document.cookie.split("; ");
            for (var i = 0; i < c.length; i++) {
                var d = c[i].split("=");
                if (d[0] == N) {
                    return unescape(d[1]);
                }
            }
            return "";
        },
        setCookie: function(N, V, Q) {
            var L = new Date();
            var z = new Date(L.getTime() + Q * 60000);
            document.cookie = N + "=" + escape(V) + ";path=/;expires=" + z.toGMTString() + ";"
        },
        getflagcookie: function(url) {
            var flag_cookie = "";
            var domain = document.domain.substr(0, (document.domain.length - 10));
            var href = document.location.href;
            var start = href.lastIndexOf("/") + 1;
            var end = href.lastIndexOf(".");
            href = href.substr(start, end - start);
            var cookie_time = new Date();
            var ti = cookie_time.getFullYear().toString() + (cookie_time.getMonth() + 1).toString() + cookie_time.getDate().toString();
            var url_start = url.indexOf("-") + 1;
            url = url.substr(url_start, 20);
            var url_end = url.indexOf("-");
            url = url.substr(0, url_end);
            flag_cookie = domain + url + href + ti;
            return flag_cookie;
        },
        browser: function() {
            var b = {},
            a = navigator.userAgent.toLowerCase();
            b.IE = /msie/.test(a);
            b.OPERA = /opera/.test(a);
            b.MOZ = /gecko/.test(a);
            b.IE6 = /msie 6/.test(a);
            b.IE7 = /msie 7/.test(a);
            b.IE8 = /msie 8/.test(a);
            b.SAFARI = /safari/.test(a);
            b.CHROME = /chrome/.test(a);
            b.IPHONE = /iphone os/.test(a);
            return b;
        },
        addEventFunction: function(obj, evt, fn) {
            if (obj.addEventListener) {
                obj.addEventListener(evt, fn, false);
            } else if (obj.attachEvent) {
                obj.attachEvent("on" + evt, fn);
            } else {
                obj["on" + evt] = fn;
            }
        },
        toArray: function(s){  
            try{  
                return Array.prototype.slice.call(s);  
            } catch(e){  
                    var arr = [];  
                    for(var i = 0,len = s.length; i < len; i++){  
                        //arr.push(s[i]);  
                        arr[i] = s[i];
                    }  
                    return arr;  
            } 
        },
        parseDom : function (arg) {
            var objE = document.createElement("div");
            objE.innerHTML = arg;
            return this.toArray(objE.childNodes);
        },
        init_html: function(style) {
            var _ = this;
            if (_.browser().IE6) {
                var html = '<div style="z-index:' + ifengcouplet3_flag_index + ';position: absolute; float:left; display:none; top: ' + style["top"] + 'px; left: ' + style["left"] + 'px; width: ' + style["width"] + 'px; height: ' + style["height"] + 'px;" id="couplet3_left">' + '<div style="position:absolute;top:0;left:0;"><div style="background:#eee;width:' + style["width"] + 'px;height:' + style["height_close"] + 'px;"><div style="font-size:12px;font-style:normal;float:right;text-align:right;cursor:pointer;text-decoration:underline;width:50px;height:' + style["height_close"] + 'px;line-height:' + style["height_close"] + 'px;" id="couplet3_left_2">关闭'+adText+'</div></div><div style="position: relative; margin:0; padding:0; top: 0px; width: ' + style["width"] + 'px; height: ' + (style["height"] - style["height_close"]) + 'px;" id="couplet3_left_1"></div>' + '</div>' + '</div>' + '<div style="z-index:' + ifengcouplet3_flag_index + ';position: absolute; display:none; top: ' + style["top"] + 'px; right: ' + style["left"] + 'px; width: ' + style["width"] + 'px; height: ' + style["height"] + 'px;" id="couplet3_right">' + '<div style="position:absolute;top:0;left:0;"><div style="background:#eee;width:' + style["width"] + 'px;height:' + style["height_close"] + 'px;"><div style="font-size:12px;font-style:normal;float:left;text-align:left;cursor:pointer;text-decoration:underline;width:50px;height:' + style["height_close"] + 'px;line-height:' + style["height_close"] + 'px;" id="couplet3_right_2">关闭'+adText+'</div></div><div style="position: relative; margin:0; padding:0; top: 0px; width: ' + style["width"] + 'px; height: ' + (style["height"] - style["height_close"]) + 'px;" id="couplet3_right_1"></div>' + '</div>' + '</div>';
            } else {
                var html = '<div style="z-index:' + ifengcouplet3_flag_index + ';position: fixed; float:left; display:none; top: ' + style["top"] + 'px; left: ' + style["left"] + 'px; width: ' + style["width"] + 'px; height: ' + style["height"] + 'px;" id="couplet3_left">' + '<div style="position:absolute;top:0;left:0;"><div style="background:#eee;width:' + style["width"] + 'px;height:' + style["height_close"] + 'px;"><div style="font-size:12px;font-style:normal;float:right;text-align:right;cursor:pointer;text-decoration:underline;width:50px;height:' + style["height_close"] + 'px;line-height:' + style["height_close"] + 'px;" id="couplet3_left_2">关闭'+adText+'</div></div><div style="position: relative; margin:0; padding:0; top: 0px; width: ' + style["width"] + 'px; height: ' + (style["height"] - style["height_close"]) + 'px;" id="couplet3_left_1"></div>' + '</div>' + '</div>' + '<div style="z-index:' + ifengcouplet3_flag_index + ';position: fixed; display:none; top: ' + style["top"] + 'px; right: ' + style["left"] + 'px; width: ' + style["width"] + 'px; height: ' + style["height"] + 'px;" id="couplet3_right">' + '<div style="position:absolute;top:0;left:0;"><div style="background:#eee;width:' + style["width"] + 'px;height:' + style["height_close"] + 'px;"><div style="font-size:12px;font-style:normal;float:left;text-align:left;cursor:pointer;text-decoration:underline;width:50px;height:' + style["height_close"] + 'px;line-height:' + style["height_close"] + 'px;" id="couplet3_right_2">关闭'+adText+'</div></div><div style="position: relative; margin:0; padding:0; top: 0px; width: ' + style["width"] + 'px; height: ' + (style["height"] - style["height_close"]) + 'px;" id="couplet3_right_1"></div>' + '</div>' + '</div>';
            }

            var htmlDom = this.parseDom(html);
            for(var i=0;i<htmlDom.length;i++){
                document.body.appendChild(htmlDom[i]);
            }
            
            var couplet3_left = document.getElementById('couplet3_left');
            var couplet3_right = document.getElementById('couplet3_right');
            var iframeStr = '<iframe width="' + style["width"] + '" height="' + style["height"] + '" border="0" frameborder="no" marginwidth="0" marginheight="0" scrolling="no"></iframe>';
            couplet3_left.innerHTML += iframeStr;
            couplet3_right.innerHTML += iframeStr;
            if (_.browser().IE6) {
                ieFunScroll();
                _.addEventFunction(window, 'scroll', ieFunScroll);
            }

            function ieFunScroll() {
                var ieScrollTop = parseInt(document.documentElement.scrollTop ? document.documentElement.scrollTop: document.body.scrollTop);
                document.getElementById('couplet3_left').style.top = document.getElementById('couplet3_right').style.top = ieScrollTop + style["top"] + 'px';
            }
        },
        init_close: function() {
            this.$('couplet3_left_2').onclick = function() {
                ifengcouplet3.setCookie(ifengcouplet3.flagcookie, '1', 60);
                ifengcouplet3.$("couplet3_left").style.display = "none";
                ifengcouplet3.$("couplet3_right").style.display = "none";
            };
            this.$('couplet3_right_2').onclick = function() {
                ifengcouplet3.setCookie(ifengcouplet3.flagcookie, '1', 60);
                ifengcouplet3.$("couplet3_left").style.display = "none";
                ifengcouplet3.$("couplet3_right").style.display = "none";
            };
        },
        flash_set: function(swfUrl, clickUrl, flagFilter, width, height, flaginteractive) { //clickUrl = clickUrl.replace(/&/g, '%26');
            var jiewei = ifengcouplet3.ext(swfUrl),
            flashHtml;
            // var jiewei = 'jpg', flashHtml;
            if (jiewei == 'swf') {
                if (flaginteractive == 0) { 
                    flashHtml = '<div><object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"	codebase="http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,0,0" width="' + ifengcouplet3_width + '" height="' + ifengcouplet3_height + '">' + '<param name="movie" value="' + swfUrl + '" />' + '<param name="quality" value="high" />' + '<param name="wmode" value="opaque" />' + '<embed src="' + swfUrl + '" quality="high" wmode="opaque" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="' + ifengcouplet3_width + '" height="' + ifengcouplet3_height + '"></embed></object></div><div onclick="window.open(\'' + clickUrl + '\');" style = "cursor:pointer; background:red; filter:alpha(opacity=' + 0 + ');-moz-opacity:0;opacity:0;position:relative; top:0px;left:0px; width:' + ifengcouplet3_width + 'px;height:' + ifengcouplet3_height + 'px;position:absolute;"></div>';
                } else if (flaginteractive == 1) { 
                    clickUrl = clickUrl.replace(/&/g, '%26');
                    flashHtml = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"	codebase="http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,0,0" width="' + ifengcouplet3_width + '" height="' + ifengcouplet3_height + '">' + '<param name="movie" value="' + swfUrl + '?clickTag=' + clickUrl + '" />' + '<param name="quality" value="high" />' + '<embed src="' + swfUrl + '?clickTag=' + clickUrl + '" quality="high" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="' + ifengcouplet3_width + '" height="' + ifengcouplet3_height + '"></embed></object>';
                }
            } else if (jiewei == "jpg" || jiewei == "png" || jiewei == "gif") {
                flashHtml = '<a href="' + clickUrl + '" target="_blank"><img border="0" src="' + swfUrl + '"/></a>';
            } else {
                flashHtml = '<iframe src="' + swfUrl + '" width="' + width + '" height="' + height + '" scrolling="no" frameborder="0"/>';
            }
            ifengcouplet3.$('couplet3_left_1').innerHTML = ifengcouplet3.$('couplet3_right_1').innerHTML = flashHtml;

        },
        /**
		 * 
		 * @param String s
		 */
        ext: function(s) {
            var pairs;
            var file;
            var ext;
            var s = s.replace(/(\\+)/g, '#');
            pairs = s.split('#');
            file = pairs[pairs.length - 1];
            pairs = file.split('.');
            ext = pairs[pairs.length - 1];
            return ext.toLowerCase();
        },
        init_play: function() {
            if (0) {} else {
                ifengcouplet3.$("couplet3_left").style.display = "block";
                ifengcouplet3.$("couplet3_right").style.display = "block";
            }
            if (typeof(IFENGDODGE) != 'undefined') {
                setTimeout('IFENGDODGE.controller.play("coupletnew");', 1000);
            }
        },
        init: function(swfUrl, clickUrl, filter, bodywidth, flagdodge, flaginteractive, width) {
            var style = {
                "top": ifengcouplet3_flag_top,
                "left": 0,
                "width": width,
                "width_close": 32,
                "height": 315,
                "height_close": 15
            };
            if (document.documentElement.clientWidth > (bodywidth + style["width"] + style["width"])) {
                style["left"] = (document.documentElement.clientWidth - (bodywidth + style["width"] + style["width"])) / 2;
                style["left"] = 1;
            } else {
                style["left"] = 0;
            }
            ifengcouplet3.init_html(style);
            ifengcouplet3.init_close();
            ifengcouplet3.flash_set(swfUrl, clickUrl, filter, style["width"], style["height"] - style["height_close"], flaginteractive);
            ifengcouplet3.flagcookie = ifengcouplet3.getflagcookie(swfUrl);
            if(ifengcouplet3.$('couplet3_left_1')){
                ifengcouplet3.$('couplet3_left_1').onclick = ifengcouplet3.$('couplet3_right_1').onclick = function() {
                    if("undefined" != typeof click_imp_arr && click_imp_arr != ''){
                        SendUrls(click_imp_arr);
                    }
                }
            };
        }
    };
    var ifengcouplet3_swfUrl = swfUrl; 
    var ifengcouplet3_clickUrl = clickUrl; 
    var ifengcouplet3_bodywidth = 1000; 
    var ifengcouplet3_width = 120; 
    var ifengcouplet3_height = 300; 
    var ifengcouplet3_flag_dodge = 1; 
    var ifengcouplet3_flag_interactive = interac; 
    var ifengcouplet3_flag_index = 9999998;
    var ifengcouplet3_flag_top = 100;
    var ifengcouplet3_filter;
    ifengcouplet3.init(ifengcouplet3_swfUrl, ifengcouplet3_clickUrl, ifengcouplet3_filter, ifengcouplet3_bodywidth, ifengcouplet3_flag_dodge, ifengcouplet3_flag_interactive, ifengcouplet3_width);
    function ifengcouplet3_play() {
        ifengcouplet3.init_play();
    }
    if (typeof(IFENGDODGE) != 'undefined' && ifengcouplet3_flag_dodge == 1) {
        IFENGDODGE.set_stock('coupletnew', {
            "timer": "8",
            "func": ifengcouplet3.init_play,
            "level": 2
        });
    } else {
        setTimeout(ifengcouplet3_play, delay * 1000);
    }

    if("undefined" != typeof imp_arr && imp_arr != ''){
        SendUrls(imp_arr);
    }
    //这里修改
    window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.on("windowAdOpen",function(){
        let cl = ifengcouplet3.$("couplet3_left"),
            cr = ifengcouplet3.$("couplet3_right");    
        if(cl != null && cr != null &&　cl.style.display != "none" && cr.style.display != "none"){
            cl.style.display = "none";
            cr.style.display = "none"; 
        }
        //关闭对联
    })
    window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.on("windowAdClose", function () {
        let cl = ifengcouplet3.$("couplet3_left"),
            cr = ifengcouplet3.$("couplet3_right");    
        if(cl != null && cr != null &&　cl.style.display != "block" && cr.style.display != "block"){
            cl.style.display = "block";
            cr.style.display = "block"; 
        }
        //init_close();
        //打开对联
    })
}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.coupletFloat = {
        render: coupletFloat,
        version: "1.0.0"
    };
}